export const songs = [
  {
    id: 1,
    songName: 'Kesariya',
    singerName: 'Arijit Singh',
    image:
      'https://res.cloudinary.com/dzajmcocc/image/upload/v1674915661/songs/kesariya_auuxzj.jpg',
    songLink:
      'https://res.cloudinary.com/dzajmcocc/video/upload/v1674915942/songs/Kesariya_PagalWorld.com.se_oqaopm.mp3',
  },
  {
    id: 2,
    songName: 'Ratan Lambiyan',
    singerName: '	Jubin Nautiyal, Asees Kaur',
    image:
      'https://res.cloudinary.com/dzajmcocc/image/upload/v1674918397/songs/ratan-lambiyan_tqebcz.jpg',
    songLink:
      'https://res.cloudinary.com/dzajmcocc/video/upload/v1674918535/songs/Raatan_Lambiyan_PagalWorld.com.se_srkbm6.mp3',
  },
  {
    id: 3,
    songName: 'hoome Jo Pathaan',
    singerName: '	Arijit Singh, Sukriti Kakar',
    image:
      'https://res.cloudinary.com/dzajmcocc/image/upload/v1674920951/songs/jhume-jo-pathan_aejtmm.jpg',
    songLink:
      'https://res.cloudinary.com/dzajmcocc/video/upload/v1674920992/songs/Jhoome_Jo_Pathaan_PagalWorld.com.se_mbffaj.mp3',
  },
  {
    id: 4,
    songName: 'Dil Galti kar baitha hai',
    singerName: 'Jubeen Nautiyal',
    image:
      'https://res.cloudinary.com/dzajmcocc/image/upload/v1674921230/songs/dil-galti-kar-baitha-haijpg_kldzio.jpg',
    songLink:
      'https://res.cloudinary.com/dzajmcocc/video/upload/v1674921309/songs/Dil_Galti_Kar_Baitha_Hai_PagalWorld.com.se_zdusiw.mp3',
  },
  {
    id: 5,
    songName: 'Dhoka',
    singerName: 'Arijit Singh',
    image:
      'https://res.cloudinary.com/dzajmcocc/image/upload/v1674921839/songs/Dhokajpg_are7kg.jpg',
    songLink:
      'https://res.cloudinary.com/dzajmcocc/video/upload/v1674921889/songs/Arijit_Singh_-_Dhokha_PagalWorld.com.se_uv1kr6.mp3',
  },
];
